import "./index.css";
import React, { memo } from "react";
import { FaPlus, FaTag } from "react-icons/fa";
import { Handle } from "reactflow";

import { ValidatorFn } from "../../../helpers/validationConnector";
import { NodeHeader } from "../../Elements/NodeHeader";
import { NodeRef } from "../../Elements/NodeRef";

export default memo(({ data, ...rest }) => {
	const chatTags =
		data.chattags
			?.filter((tag) => {
				return data?.chatTags?.includes(tag._id);
			})
			?.map((tag) => tag.name)
			?.join(", ") || "";
	return (
		<>
			<NodeRef nodeRef={data.ref} />
			<Handle type="target" position="left" isConnectable={true} isConnectableStart={false} />

			<NodeHeader
				rest={rest}
				data={data}
				icon={<FaTag />}
				text="Definir tags na conversa"
			/>

			<div className="sendMessageContent">
				<div>
					Adicionar: <b>{chatTags}</b>
				</div>
			</div>

			<Handle
				type="source"
				position="right"
				className="handle"
				isConnectable={true}
				isValidConnection={ValidatorFn()}
			>
				<FaPlus size={8} style={{ pointerEvents: "none" }} />
			</Handle>
		</>
	);
});
